module.exports = __webpack_public_path__ + "img/banner.04dde44e.jpg";